module.exports = __webpack_public_path__ + "img/yilianGl19.95a44789.png";